<template>
  <v-dialog v-model="model" :max-width="maxWidth" :persistent="persistent">
    <v-card>
      <v-card-title class="headline" primary-title>{{ title }}</v-card-title>
      <v-card-text v-if="description">{{ description }}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error darken-1" flat @click.native="$emit('yes')">Yes</v-btn>
        <v-btn color="secondary" flat @click.native="$emit('cancel')">{{cancelText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MPayConfirmDialog',

  props: {
    show: { type: Boolean, required: true },
    title: { type: String, required: true },
    description: { type: String, required: false },
    persistent: { type: Boolean, required: false, default: false },
    maxWidth: { type: String, required: false, default: '500px' },
    cancelText: { type: String, required: false, default: 'Cancel' },
  },

  data: () => ({

  }),

  computed: {
    model: {
      get() {
        return this.show;
      },
      set(newValue) {
        if (!newValue) {
          this.$emit('cancel');
        }
      },
    },
  },

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MPayConfirmDialog.vue